import React from 'react';
import './Footer.css';
import MSILKLogo from '../assets/footerlogo.PNG';

const Footer = () => {
  return (
    <>
<div id="footer" className="bg- text-light" style={{ backgroundColor: "#e7c6c6" }}>
  <div className="container py-4">
    <div className="row justify-content-between align-items-start pb-">
      
      {/* Logo Section */}
      <div className="col-12 col-md-4 pt-3 text-start ">
        <img src={MSILKLogo} alt="Avatar Logo" style={{ width: '200px' }} />
      </div>

      {/* Address & Contact Table */}
      <div className="col-12 col-md-8 pt-4">
        <table className="w-100 footertable table-borderless table-sm text-start text-dark" style={{ whiteSpace: 'nowrap' }}>
          <thead>
            <tr>
              <th className='footerth'  style={{ fontSize: '13px', fontWeight: 'bold' }}>Address:</th>
              <th className='footerth' style={{ fontSize: '13px', fontWeight: 'bold' }}>Hours of Operation:</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='footertd' style={{ fontSize: '13px' }}>719 Avenue U Brooklyn, NY 11223</td>
              <td className='footertd' style={{ fontSize: '13px' }}>Mon - Fri: 9 AM - 6 PM</td>
            </tr>
            <tr>
              <th className='footerth 'style={{ fontSize: '13px', fontWeight: 'bold' }}>Phone:</th>
              <th className='footerth' style={{ fontSize: '13px', fontWeight: 'bold' }}>Email:</th>
            </tr>
            <tr>
              <td className='footertd' style={{ fontSize: '13px' }}>+1 920-920-0707</td>
              <td className='footertd' style={{ fontSize: '13px' }}>medina@frontiersgi.com</td>
            </tr>
        
          </tbody>
        </table>
      </div>
    </div>

    <hr className="text-dark" />

    {/* Footer Links Section */}
    <div className="row justify-content-between pb-3">
      <div className="col-12 col-md-6 text-start">
        <span className="foote">Privacy Policy</span>
        <span className="foote ps-5">Terms of Service</span>
        <span className="foote ps-5">Cookies Settings</span>
      </div>
      <div className="col-12 col-md-6 text-md-end">
        <span className="footee">2025 MSilk Spa. All rights reserved.</span>
      </div>
    </div>
    
    <div>        
      
    </div>

  </div>
</div>

</>
  )
}

export default Footer